/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum BboxIntersectionPointEnum {
    TOP_RIGHT = 'top right',
    MIDDLE_RIGHT = 'middle right',
    BOTTOM_RIGHT = 'bottom right',
    TOP_CENTER = 'top center',
    MIDDLE_CENTER = 'middle center',
    BOTTOM_CENTER = 'bottom center',
    TOP_LEFT = 'top left',
    MIDDLE_LEFT = 'middle left',
    BOTTOM_LEFT = 'bottom left',
}